// tslint:disable max-line-length

import * as Constants from "Data/Constants";
import {RIO as VO} from "Data/VO";
import type { ILocationConfig } from "Interfaces/ILocationConfig";

export const RioConfig: ILocationConfig = {
  city: "Rio de Janeiro",
  country: "Brazil",
  interior: {
    width: 1664,
    itemslist: {
      give: {
        bg: [
          { filename: "clipboard", x: 30, y: -100 },
          { filename: "float-platform", x: 0, y: 215, dontAnimateIn: true },
        ],
        ICON_SIZE: 100,
        ICON_SPACING: 25,
        columns: 4,
        floatingItemsY: -180,
        width: 440,
        highlightFloatingItems: false,
        animateIn: "slideInFromRight",
      },
      return: {
        width: 0,
        height: 0,
        highlightFloatingItems: true,
        floatingItemsY: -250,
        ICON_SIZE: 100,
        ICON_SPACING: 25,
        itemslots: [
          {
            x: 0,
            y: 128,
            width: 480,
            height: 300,
            acceptsMultiple: true,
            hideIconImmediately: true,
            bg: [{ filename: "itemring", x: 0, y: 40 }],
            scaleUpOnDragOver: true,
            dropSFX: "powerup-shield",
          },
        ],
        animateOut: "fade",
      },
    },
    bg: { filename: "rio-int-bg" },
  },
  exterior: {
    bg: [
      { filename: "rio-ext-bg1", x: 0, y: 0 },
      { filename: "rio-ext-bg2", x: 2048, y: 0 },
    ],
    margin: {
      left: 10,
      right: 10,
    },
    width: 3072,
  },
  items: {
    // "fabric": {
    //   name: "Fabric",
    //   sprite: "fabric-full",
    //   sprite_hat: "fabric-full",
    //   icon_int_give: "fabric-full",
    //   icon_int_return: "fabric-full",
    //   icon_ext: "fabric-on",
    // },
    "sewing-machine": {
      name: "Sewing Machine",
      sprite: "sewing-machine-full",
      sprite_hat: "sewing-machine-full",
      icon_int_give: "sewing-machine-full",
      icon_int_return: "sewing-machine-full",
      icon_ext: "sewing-machine-on",
      vo: {
        found: VO.IR2B,
        returned: VO.IR2A,
        fact: VO.FR8,
      },
    },
    // "blowtorch": {
    //   name: "Blowtorch",
    //   sprite: "blowtorch-full",
    //   sprite_hat: "blowtorch-full",
    //   icon_int_give: "blowtorch-full",
    //   icon_int_return: "blowtorch-full",
    //   icon_ext: "blowtorch-on",
    // },
    "tape": {
      name: "Tape",
      sprite: "tape-full",
      sprite_hat: "tape-full",
      icon_int_give: "tape-full",
      icon_int_return: "tape-full",
      icon_ext: "tape-on",
      vo: {
        found: VO.IR9B,
        returned: VO.IR9A,
      },
    },
    // "scissors": {
    //   name: "Scissors",
    //   sprite: "scissors-full",
    //   sprite_hat: "scissors-full",
    //   icon_int_give: "scissors-full",
    //   icon_int_return: "scissors-full",
    //   icon_ext: "scissors-on",
    // },
    "palette": {
      name: "Palette",
      sprite: "palette-full",
      sprite_hat: "palette-full",
      icon_int_give: "palette-full",
      icon_int_return: "palette-full",
      icon_ext: "palette-on",
      vo: {
        found: VO.IR4B,
        returned: VO.IR4A,
        fact: VO.FR10,
      },
    },
    "paint-bucket": {
      name: "Paint Bucket",
      sprite: "paint-bucket-full",
      sprite_hat: "paint-bucket-full",
      icon_int_give: "paint-bucket-full",
      icon_int_return: "paint-bucket-full",
      icon_ext: "paint-bucket-on",
      vo: {
        found: VO.IR7B,
        returned: VO.IR7A,
      },
    },
    "paint-brush": {
      name: "Paint Brush",
      sprite: "paint-brush-full",
      sprite_hat: "paint-brush-full",
      icon_int_give: "paint-brush-full",
      icon_int_return: "paint-brush-full",
      icon_ext: "paint-brush-on",
      vo: {
        found: VO.IR1B,
        returned: VO.IR1A,
        fact: VO.FR7,
      },
    },
    "cardboard": {
      name: "Cardboard",
      sprite: "cardboard-full",
      sprite_hat: "cardboard-full",
      icon_int_give: "cardboard-full",
      icon_int_return: "cardboard-full",
      icon_ext: "cardboard-on",
      vo: {
        found: VO.IR5B,
        returned: VO.IR5A,
      },
    },
    "glue": {
      name: "Glue",
      sprite: "glue-full",
      sprite_hat: "glue-full",
      icon_int_give: "glue-full",
      icon_int_return: "glue-full",
      icon_ext: "glue-on",
      vo: {
        found: VO.IR8B,
        returned: VO.IR8A,
        fact: VO.FR9,
      },
    },
    "ruler": {
      name: "Ruler",
      sprite: "ruler-full",
      sprite_hat: "ruler-full",
      icon_int_give: "ruler-full",
      icon_int_return: "ruler-full",
      icon_ext: "ruler-on",
      vo: {
        found: VO.IR3B,
        returned: VO.IR3A,
      },
    },
    "tapemeasure": {
      name: "Tape Measure",
      sprite: "tapemeasure-full",
      sprite_hat: "tapemeasure-full",
      icon_int_give: "tapemeasure-full",
      icon_int_return: "tapemeasure-full",
      icon_ext: "tapemeasure-on",
      vo: {
        found: VO.IR6B,
        returned: VO.IR6A,
        fact: VO.FR6,
      },
    },
  },
  payoffs: {
    float1: { name: "Float 1", sprite: ["float1-1", "float1-2", "float1-3", "float1-4"], position: { x: 0, y: -70 } },
    float2: { name: "Float 2", sprite: ["float2-1", "float2-2", "float2-3", "float2-4", "float2-5"], position: { x: 0, y: -70 } },
    float3: { name: "Float 3", sprite: ["float3-1", "float3-2", "float3-3", "float3-4", "float3-5"], position: { x: 0, y: -70 } },
    float4: { name: "Float 4", sprite: ["float4-1", "float4-2", "float4-3", "float4-4", "float4-5", "float4-6"], position: { x: 0, y: -70 } },
    float5: { name: "Float 5", sprite: ["float5-1", "float5-2", "float5-3", "float5-4", "float5-5", "float5-6", "float5-7", "float5-8"], position: { x: 0, y: -70 } },
  },
  hidingspots: {
    "left-fan": {
      hitarea: { x: 68.5, y: 129 },
      foreground: { sprite: "left-fan", x: 0, y: 91 },
    },
    "left-corner-tablet": {
      hitarea: { x: 0, y: 667.5 },
      foreground: { sprite: "left-corner-tablet", x: 0, y: 667.5 },
    },
    "ladder": {
      hitarea: { x: 486, y: 377 },
      foreground: { sprite: "ladder", x: 249.5, y: 595 - 634 },
    },
    "foam-piece": {
      hitarea: { x: 572, y: 565.5 },
      foreground: { sprite: "foam-piece", x: 572, y: 565.5 },
    },
    "wall-barrel": {
      hitarea: { x: 1091.5, y: 205.5 },
      foreground: { sprite: "wall-barrel", x: 1024, y: 190 },
    },
    "purple-pillar1": {
      hitarea: { x: 796, y: 0 },
      foreground: { sprite: "purple-pillar-1", x: 796, y: 481 - 714 },
    },
    "large-green-pipe": {
      hitarea: { x: 1736.5, y: 307.5 },
      foreground: { sprite: "large-green-pipe", x: 1690.5, y: 159 },
    },
    "metal-pipes": {
      hitarea: { x: 1765.5, y: 435 },
      foreground: { sprite: "metal-pipes", x: 1578.5, y: 369.5 },
    },
    "sun-flower": {
      background: { sprite: "table", x: 1216, y: 320.5 },
      hitarea: { x: 1326.5, y: 393 },
      foreground: { sprite: "sun-flower", x: 1151.5, y: 355 },
    },
    "purple-pillar2": {
      hitarea: { x: 2061, y: 355 },
      foreground: { sprite: "purple-pillar-2", x: 1981, y: -182 },
    },
    "gas-tank": {
      hitarea: { x: 2822.5, y: 320 },
      foreground: { sprite: "gas-tank", x: 2798, y: 175.5 },
    },
    "orange-flower": {
      hitarea: { x: 2562, y: 526 },
      background: { sprite: "table-with-mug", x: 2347, y: 369.5 },
      foreground: { sprite: "orange-flower", x: 2532.5, y: 379 },
    },
    "green-pipe": {
      hitarea: { x: 2848.5, y: 240 },
      foreground: { sprite: "green-pipe", x: 2848.5, y: 240 },
    },
    "purple-flower": {
      hitarea: { x: 796.5, y: 453.5 },
      foreground: { sprite: "purple-flower", x: 796.5, y: 453.5 },
    },
    "hand": {
      hitarea: { x: 2247, y: 492.5 },
      foreground: { sprite: "hand", x: 2135, y: 332.5 },
    },
    "sewing-table": {
      hitarea: { x: 610.5, y: 688.5 },
      foreground: { sprite: "sewing-table", x: 610.5, y: 688.5 },
    },
    "fabricroll-greenblue": {
      hitarea: { x: 1079, y: 719 },
      foreground: { sprite: "fabricroll-greenblue", x: 1013, y: 597 },
    },
    "purple-shape": {
      hitarea: { x: 2036.5, y: 708 },
      foreground: { sprite: "purple-shape", x: 1590.5, y: 643.5 },
    },
    "barrel": {
      hitarea: { x: 1696.5, y: 740.5 },
      foreground: { sprite: "barrel", x: 1427.5, y: 634.5 },
    },
    "fabricroll-red": {
      hitarea: { x: 2665.5, y: 695.5 },
      foreground: { sprite: "fabricroll-red", x: 2625, y: 609.5 },
    },
    "fabricroll-purpleblue": {
      hitarea: { x: 3031.5, y: 691 },
      foreground: { sprite: "fabricroll-purpleblue", x: 2827.5, y: 631.5 },
    },
  },
  npc: {
    name: "Raquel",
    poses: {
      neutral: {sprite: "npc-raquel-neutral", position: {x: -18, y: 0}},
      excited: {sprite: "npc-raquel-excited"},
    },
  },
  vo: {
    give_quest: [VO.R1],
    show_items: [VO.R2, Constants.VO_SPACING, VO.R3],
    give_quest_idle: [VO.R4, VO.R5],
    return_items: [VO.R8, Constants.VO_SPACING, VO.R9],
    return_items_idle: [VO.R9],
    exterior: [VO.R6, Constants.VO_SPACING, VO.R7],
    exterior_idle: [VO.FR1, VO.FR2, VO.FR3, VO.FR4/* , VO.FR5 */],
    all_items_returned_idle: [VO.R13],
  },
  narratives: [
    {
      variations: [
// Level 1
        {
          hiddenitems: [
            {hidingspot: "ladder", item: { id: "paint-brush", scale: 0.6261, position: {x: 58.75, y: 19.5}, rotation: 173.84 }},
            {hidingspot: "sun-flower", item: { id: "sewing-machine", scale: 0.5672, position: {x: -2, y: -45.5} }},
            {hidingspot: "barrel", item: { id: "ruler", scale: 0.7421, position: {x: 64.5, y: -6} }},
            {hidingspot: "gas-tank", item: { id: "palette", scale: 0.5420, position: {x: -36, y: 14.5}, rotation: -59.86 }},
          ],
          itemslist: {
            give: {
              floatingItemsY: -105,
            },
          },
        },
      ],
      payoff: "float1",
      vo: {
        all_items_returned: [VO.R11, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 2
        {
          hiddenitems: [
            {hidingspot: "left-fan", item: { id: "palette", scale: 0.6158, position: {x: 30.5, y: 8.25}, rotation: 38.18, flipX: true }},
            {hidingspot: "wall-barrel", item: { id: "cardboard", scale: 0.5924, position: {x: 37.75, y: 32.25}, rotation: 9.79, flipX: true }},
            {hidingspot: "fabricroll-greenblue", item: { id: "glue", scale: 0.6507, position: {x: -61, y: 11.75}, rotation: -58.20, flipX: true }},
            {hidingspot: "hand", item: { id: "paint-bucket", scale: 0.5844, position: {x: -19.25, y: -32.75}, rotation: -2.74 }},
            {hidingspot: "fabricroll-purpleblue", item: { id: "tape", scale: 0.7404, position: {x: -32, y: -32.5}, rotation: -28.09, flipX: true }},
          ],
          itemslist: {
            give: {
              columns: 3,
            },
          },
        },
      ],
      payoff: "float2",
      vo: {
        all_items_returned: [VO.R12, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 3
        {
          hiddenitems: [
            {hidingspot: "ladder", item: { id: "tapemeasure", scale: 0.7404, position: {x: 49.5, y: 4.75}, rotation: 0, flipX: false }},
            {hidingspot: "barrel", item: { id: "cardboard", scale: 0.7399, position: {x: 44.5, y: 5.25}, rotation: -169.33, flipX: false }},
            {hidingspot: "purple-pillar2", item: { id: "glue", scale: 0.5207, position: {x: -19.5, y: 8.25}, rotation: -53.95, flipX: false }},
            {hidingspot: "orange-flower", item: { id: "ruler", scale: 0.4899, position: {x: -6, y: -49}, rotation: -27.76, flipX: false }},
            {hidingspot: "sun-flower", item: { id: "paint-brush", scale: 0.5273, position: {x: -90, y: -5.75}, rotation: 162.14, flipX: false }},
          ],
          itemslist: {
            give: {
              columns: 3,
            },
          },
        },
      ],
      payoff: "float3",
      vo: {
        all_items_returned: [VO.R11, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
// Level 4
        {
          hiddenitems: [
            {hidingspot: "left-fan", item: { id: "glue", rotation: 85.52, flipX: false, position: {x: -9.5, y: 365.25}, scale: 0.4498 }},
            {hidingspot: "sun-flower", item: { id: "tape", rotation: 132.65, flipX: true, position: {x: -129.5 - 15, y: 26.5}, scale: 0.4802 }},
            {hidingspot: "fabricroll-greenblue", item: { id: "sewing-machine", position: {x: -27.5 - 25, y: 9 - 50}, scale: 0.7387  }},
            {hidingspot: "hand", item: { id: "palette", rotation: 72.59, flipX: false, position: {x: -4, y: -25.25}, scale: 0.56  }},
            {hidingspot: "orange-flower", item: { id: "cardboard", rotation: 23.61, flipX: false, position: {x: 111 + 25, y: -33.75 - 25}, scale: 0.5256 }},
            {hidingspot: "fabricroll-purpleblue", item: { id: "paint-brush", rotation: 170.43, flipX: true, position: {x: -175, y: 47.75 - 50}, scale: 0.7391 }},
          ],
          itemslist: {
            give: {
              columns: 3,
            },
          },
        },
      ],
      payoff: "float4",
      vo: {
        all_items_returned: [VO.R12, Constants.VO_SPACING, VO.R13],
      },
    },
    {
      variations: [
        // Level 5
        {
          hiddenitems: [
            {hidingspot: "left-fan", item: { id: "cardboard", scale: 0.6158, position: {x: -28.5 + 65, y: 27}, rotation: -4.20, flipX: false }},
            {hidingspot: "ladder", item: { id: "paint-bucket", scale: 0.53, position: {x: 21.5 + 20, y: 34.75}, rotation: 13.94, flipX: false }},
            {hidingspot: "wall-barrel", item: { id: "glue", scale: 0.468, position: {x: -62.25, y: 102}, rotation: -61.51, flipX: false }},
            {hidingspot: "barrel", item: { id: "palette", scale: 0.7389, position: {x: 38 - 40, y: 0 - 60}, rotation: -46.73, flipX: false }},
            {hidingspot: "large-green-pipe", item: { id: "tape", scale: 0.4802, position: {x: -37.51 - 20, y: 9}, rotation: -142.49, flipX: true }},
            {hidingspot: "orange-flower", item: { id: "sewing-machine", scale: 0.4776, position: {x: 121 + 25, y: -28.25}, rotation: 0, flipX: false }},
            {hidingspot: "gas-tank", item: { id: "ruler", scale: 0.4892, position: {x: -18, y: -14.5}, rotation: -8.19, flipX: true }},
            {hidingspot: "fabricroll-purpleblue", item: { id: "tapemeasure", scale: 0.741, position: {x: -46, y: -15}, rotation: 45, flipX: true }},
          ],
          itemslist: {
            give: {
              columns: 4,
            },
          },
        },
      ],
      payoff: "float5",
      vo: {
        all_items_returned: [VO.R11, Constants.VO_SPACING, VO.R13],
      },
    },
  ],
  bgm: "LATW_953_happy_pacer_think_mark_samba_brazil_AP_tweaked",
};
